<template>
  <section class="about-top">
    <div class="about-top__content">
      <picture class="about-top__picture">
        <source
          srcset="../../../../../../images/bulk_personal_orders/about/bulk_order_title_for_sp.png"
          alt="大人数に配りたい時はまとめてオーダー"
          media="(max-width: 767px)"
        />
        <img
          src="../../../../../../images/bulk_personal_orders/about/bulk_order_title.png"
          alt="大人数に配りたい時はまとめてオーダー"
        />
      </picture>
    </div>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped>
.about-top {
  background-color: $primary-lighten;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  &__content {
    display: flex;
    max-width: 1440px;
    width: 100%;
    padding: 88px 110px;
    gap: 43px;
    align-items: center;
    justify-content: center;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 34px 84px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 18px 58px;
    }
  }

  &__picture {
    & > img,
    source {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
